<template>
    <v-btn class="text-transform-none white--text" color="blue lighten-2" :outlined="copied" rounded :icon="icon" :small="small" @click.stop="copyLink()">
        <v-icon :left="!icon" :small="small" v-text="copied ? 'mdi-check' : 'mdi-content-copy'"></v-icon>
        <span v-if="!icon">
            {{ copied ? "Copied" : "Copy link" }}
        </span>
    </v-btn>
</template>

<script>
export default {
    props: {
        link: {
            type: String,
            default: "",
        },
        small: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            copied: false,
        };
    },
    methods: {
        async copyLink() {
            try {
                await navigator.clipboard.writeText(this.link);
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 3000);
            } catch (error) {
                this.notifyErrorMessage({
                    message: "An error occurred while copying",
                    timeout: true,
                });
            }
        },
    },
};
</script>
